import React from "react";

const CATEGORIES = [
  "Home Services", "Beauty & Wellness", "Dining", "Local Retail",
  "Fitness", "Auto Care", "Pet Services", "Events",
];

export default function TrustStrip() {
  const allChips = [...CATEGORIES, ...CATEGORIES, ...CATEGORIES];

  return (
    <section data-testid="trust-strip-section" className="py-24 border-y border-bhyyve-border/60 bg-bhyyve-bg overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12">
        <p className="text-center text-sm tracking-wider uppercase font-semibold text-bhyyve-emerald">
          Built for the future of local commerce
        </p>
        <p className="text-center mt-4 font-heading text-3xl sm:text-4xl text-bhyyve-ink tracking-tight font-medium">
          Vendors and partners across every category your day needs.
        </p>
      </div>

      <div className="relative">
        {/* Gradient fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-bhyyve-bg to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-bhyyve-bg to-transparent z-10" />

        <div className="flex animate-marquee whitespace-nowrap gap-5">
          {allChips.map((cat, i) => (
            <span
              key={i}
              data-testid={`partner-chip-${i}`}
              className="inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-white border border-bhyyve-border text-base font-medium text-bhyyve-muted hover:text-bhyyve-emerald hover:border-bhyyve-emerald/30 transition-colors"
            >
              <span className="w-2 h-2 rounded-full bg-bhyyve-emeraldLight" />
              {cat}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
